import { createClient } from '@supabase/supabase-js';
import { criarFetchComRenovacao, type Renovar } from '@/lib/fetch-com-renovacao';
import { criarRenovadorDaSessao } from '@/lib/renovar-sessao';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY não configurados. Veja .env.example.',
  );
}

// Client sem Database generic. A camada `src/services/datasources/`
// converte rows → tipos de domínio explicitamente via helpers
// `rowToX(...)`. Isso evita brigas com a inferência estrita do
// supabase-js v2.105+ sobre Insert/Update quando o schema usa brand
// types e interfaces sem index signature.
// Quando `supabase gen types` for hookado, restauramos:
//   import type { Database } from '@/types/database';
//   export const supabase = createClient<Database>(url, anonKey, ...);
//
// GUPM-336: o `fetch` renova a sessão quando o PostgREST recusa o JWT por vencido
// (`401 PGRST303`) e repete a requisição. O auth-js só renova quando o relógio do PC
// diz que venceu — numa estação atrasada isso nunca acontece. Ligação tardia porque o
// fetch precisa do client para renovar e o client precisa do fetch para existir.
// `(i, o) => fetch(i, o)` e não `fetch` direto: resolve o global na hora da chamada.
let renovarSessao: Renovar = async () => null;

export const supabase = createClient(url, anonKey, {
  auth: { persistSession: true, autoRefreshToken: true },
  global: { fetch: criarFetchComRenovacao((i, o) => fetch(i, o), () => renovarSessao()) },
});

renovarSessao = criarRenovadorDaSessao(supabase.auth);
